require('./payrollLoanGridImages.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const Immutable = require('immutable');
const isEqual = require('lodash/lang/isEqual');
// @components
const GridImagesSelector = require('../../contractPayrollLoan/payrollLoanGridImages/gridImagesSelector');

// @constants
const { PURPOSES } = require('../../contractPayrollLoan/payrollLoanPurposes');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

class PayrollLoanGridImages extends React.Component {
    constructor(props) {
        super(props);

        this.handleSelectedCard = this.handleSelectedCard.bind(this);
    }

    buildError() {
        const {
            immContractLoan,
            isDragoFeature,
            required,
            validate,
        } = this.props;

        const selectedPurpose = isDragoFeature ? immContractLoan.get('selectedPurposeDrago') : immContractLoan.get('selectedPurpose');
        const isError = required && validate && isEqual(selectedPurpose, '');

        return isError ? (

            <FormattedText
                className="col-md-12 payroll-loan-grid-selector__error"
                value="payrollLoanRequestStepOne-gridSelectorError"
            />
        ) : null;
    }

    handleSelectedCard(type, purpose) {
        const { setPurpose } = this.props;
        setPurpose(type, purpose);
    }

    render() {
        const {
            immContractLoan,
            isDragoFeature,
        } = this.props;

        const purposeType = isDragoFeature ? "selectedPurposeDrago" : "selectedPurpose";
        const selectedPurposeId = immContractLoan.get(purposeType);
        const error = this.buildError();

        let sliderImages = immContractLoan.get('newPurposesList');

        if (!isDragoFeature) {
            sliderImages = Immutable.fromJS(Object.keys(PURPOSES).map(purpose => ({
                id: PURPOSES[purpose].id,
                icon: PURPOSES[purpose].icon,
                text: formatText(PURPOSES[purpose].text)
            })));
        }


        return (
            <div className="payroll-loan-grid-selector">
                <GridImagesSelector
                    customIconPositionClass={"payroll-loan-grid-selector__icon-position"}
                    roundedImages
                    customContentClass={"payroll-loan-grid-selector__content"}
                    selectedOptionId={selectedPurposeId}
                    label="payrollLoanRequestStepOne-sliderTitle"
                    images={sliderImages}
                    isDragoFeature={isDragoFeature}
                    onChange={purpose => this.handleSelectedCard(purposeType, purpose)}
                />
                {error}
            </div>
        )
    }
}

PayrollLoanGridImages.propTypes = {
    setPurpose: PropTypes.func.isRequired,
    immContractLoan: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
    required: PropTypes.bool,
    validate: PropTypes.bool
};

module.exports = PayrollLoanGridImages;
